module.exports = __webpack_public_path__ + "img/RESERVATION_GRILLE_POINTAGE.010cf0da.svg";